import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { OverlayPanel } from "primeng/overlaypanel";
import { DebounceService } from "src/app/services/debounce.service";
import { GLOBAL_CONSTANT } from "../../common/constant/global.constant";
import { SessionService } from "../../common/services/session.service";
import { UtilityService } from "../../shared/utility.service";
import { KaryakartaInterface } from "../karyakarta.interface";
import { KaryakartaService } from "../karyakartaService/api/karyakarta.service";

//import * as data from "../../../assets/page-configs/karyakarta-list.json";
var pageConfigFromJson = require("../../../assets/page-configs/karyakarta-list.json");

@Component({
  selector: "app-top-karyakarta",
  templateUrl: "./top-karyakarta.component.html",
  styleUrls: ["./top-karyakarta.component.scss"],
})
export class TopKaryakartaComponent implements OnInit {
  @ViewChild("filter", { static: false }) filter: OverlayPanel;
  cols: any[];
  KaryakartaData: KaryakartaInterface;
  TopKaryakartas: any;
  userInfo: any;
  officeId: any;
  isActionAllowed: boolean = false;
  isPagination: boolean = true;
  isVirtualView: any;
  officeNameAllowed: boolean;
  allowViewAllStats: boolean;
  KaryakartaObj: KaryakartaInterface;
  karyakartaStatus: any = "active";
  deleteData: any;
  dialougFlag: boolean = false;
  userFlag: boolean = false;
  entityName: string = "profileImage";
  // filter
  filterObj: any;
  dateFrom: Date;
  dateTo: Date;
  dobFrom: Date;
  dobTo: Date;
  filterFlag: boolean = false;
  genderTypes: any;
  optionTypes: any;
  selectetOptionType: any;
  expandedColumnLength = 5;
  defaultPage: any;
  page: any;
  size: any;
  paginationCount: any;
  config: any;
  isLoading = false;
  searchTimeout: any;
  lastDeletedRecord: any = null;
  restoreDialogFlag = false;




  // statusFlag: any = "active";
  chartOptions = {
    title: {
      display: false,
      text: "My Title",
    },
    legend: {
      display: false,
    },
    cutoutPercentage: 80, //Here for innerRadius. It's already exists
    outerRadius: 100, //Here for outerRadius
  };
  constructor(
    private karyakartaService: KaryakartaService,
    private session: SessionService,
    private toast: MessageService,
    private router: Router,
    private us: UtilityService,
    private debounceService: DebounceService
  ) {
    this.TopKaryakartas = [];
    this.isActionAllowed = false;
    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.optionTypes = GLOBAL_CONSTANT.ACTIVE_INACTIVE;
    this.defaultPage = {
      page: {
        number: 0,
        size: this.size,
      },
    };
    this.clearFilter();
  }

  getTopKaryakartas(user) {
    this.karyakartaService.getTopKaryakartas(user).subscribe(
      (resp) => {
        this.TopKaryakartas = resp[0];
        this.paginationCount = resp[1];
        if (!this.isPagination) {
          this.TopKaryakartas = this.TopKaryakartas.slice(0, 5);
        }
      },
      (error) => {}
    );
  }

  getPageConfig() {
    //    this.karyakartaService.getPageConfig().subscribe((res) => {
    this.config = JSON.parse(JSON.stringify(pageConfigFromJson));
    if (!this.isPagination) {
      this.config.karyakartaDataList.lazyLoad = false;
      this.config.karyakartaDataList.pagination = false;
      this.config.karyakartaDataList.recordsPerPage = 2;
      this.page = {
        number: 0,
        size: 2,
      };
      if (
        (this.router.url && this.router.url.indexOf("/admin-dashboard") > -1) ||
        (this.router.url && this.router.url.indexOf("/viewer-dashboard") > -1)
      ) {
        this.config["karyakartaDataList"].columns = this.config[
          "karyakartaDataList"
        ].columns.filter((col) => ["Actions"].includes(col.header) == false);
      }
      this.getTopKaryakartas({ page: this.page });
    }
    //  });
  }

  handleEvent(event) {
    if (event.name == "LAZY_LOAD") {
      this.page = this.us.PaginationPerPage(event.event);
      this.defaultPage.page.size = event.event.rows;
      if (this.filterFlag) {
        this.filterObj.page = this.page;
        this.getTopKaryakartas(this.filterObj);
      } else {
        this.getTopKaryakartas({ page: this.page });
      }
    }
  }

  // sample click handler from action template
  onEdit($event, rowData) {
    let karyakartaId = rowData ? rowData.id : Number;
    this.router.navigate(["/karyakarta/edit/" + karyakartaId]);
  }

  onDelete($event, rowData) {
    this.dialougFlag = true;
    this.deleteData = rowData;
  }

  //soft Delete Call
  deleteRecord(karyakartaData) {
    karyakartaData.recordStatus = "DELETED";
    this.karyakartaService.updateData(karyakartaData).subscribe((res) => {
      this.dialougFlag = false;
      this.toast.add({
        severity: "error",
        summary: "Deleted Successfully",
        detail: "karyakarta Entry Deleted successfully !!!",
      });
    });
  }

  changeStatus(karyakarta) {
    karyakarta.status = !karyakarta.status;
    // this.statusFlag = true;
    this.karyakartaService.changeUserStatus(karyakarta).subscribe(
      (resp) => {
        // this.TopKaryakartas = resp;
      },
      (error) => {}
    );
  }

  deleteKaryakarta(id) {
    this.karyakartaService.deleteKaryakartaData(id).subscribe((resp) => {});
  }

  //   filter
  clearFilter() {
    this.filterObj = {
      gender: undefined,
      status: undefined,
      selectetOptionType: undefined,
      search: undefined,
    };
    this.selectetOptionType = undefined;
  }
  setFilterObject() {
    this.clearFilter();
    this.getTopKaryakartas(this.defaultPage);
    this.filterFlag = false;
  }
  searchByOption() {
    this.karyakartaStatus === "active"
      ? (this.KaryakartaObj.status = true)
      : (this.KaryakartaObj.status = false);
  }

  Filter(event, overlaypanel: OverlayPanel) {
    overlaypanel.toggle(event);
  }
  searchTerm: string = '';

  onSearchInputChange(event: any) {
      
    this.searchTerm = event.target.value;

    if (this.searchTerm.length < 2) {
      return;
    }
  
    this.debounceService.triggerSearch(this.searchTerm);
  }

  handelSubmit(term:string) {
    this.isLoading=true;
    this.filterFlag = true;
    
    if (this.selectetOptionType !== undefined) {
      this.filterObj.status = this.selectetOptionType["value"];
    } else {
      this.filterObj.status = null;
    }
    if (this.page !== undefined) {
      this.filterObj.page = this.page;
    } else {
      this.filterObj.page = "";
    }
    this.getTopKaryakartas(this.filterObj);
    this.filter.hide();
    this.isLoading=false;
  }

  ngOnInit() {
    this.userInfo = this.session.getUserInfo();

    if (
      this.userInfo &&
      (this.userInfo.role === "SUPER_ADMIN" ||
        this.userInfo.role === "OFFICE_ADMIN")
    ) {
      this.userFlag = true;
      if (this.router.url && this.router.url.indexOf("/karyakarta/list") > -1) {
        this.isActionAllowed = true;
        this.expandedColumnLength = 7;
      }
    }
    if (
      this.isVirtualView ||
      this.allowViewAllStats ||
      this.userInfo.role === "SUPER_ADMIN" ||
      this.userInfo.role === "VIEWER"
    ) {
      this.officeNameAllowed = true;
    }

    if (this.router.url && this.router.url.indexOf("/karyakarta/list") > -1) {
      this.isPagination = true;
      this.isActionAllowed = true;
    } else {
      this.isPagination = false;
      this.isActionAllowed = false;
    }
    this.getPageConfig();
  // Listen for search input and call API after debounce
  this.debounceService.search$.subscribe(term => {
    this.handelSubmit(term);
  });

  // Listen for loader state
  this.debounceService.loading$.subscribe(state => {
    this.isLoading = state;
  });
    
  }
  
  ngOnDestroy() {
    this.debounceService.setLoading(false); 
  }
 // Fetch fields from API
onUndo(event: Event, rowData: any) {  
  rowData.recordStatus = 'ACTIVE';  
    rowData.deleted = true;   
    this.restoreData(rowData);
}

restoreData(rowData: any) {
  if (!this.restoreData) return;
  this.karyakartaService.restoreRecord(rowData).subscribe(
    (resp) => {
      this.restoreDialogFlag = true;
      console.log('Record restored successfully:', resp);
      // this.setStatusData({ index: parseInt(this._index, 10) });
      
      this.toast.add({
        severity: 'success',
        summary: 'Restored Successfully',
        detail: 'The record has been successfully restored.',
      });
    },
        (error) => {
          console.error('Error restoring data:', error);
          this.toast.add({
            severity: 'error',
            summary: 'Error Restoring Record',
            detail: 'There was an error while restoring the record.',
          });
        }
  );
}
}
